import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import Styles from './vm-profile-image.scss';

@customElement('vm-profile-image')
export class VmProfileImage extends LitElement {
    static override styles = Styles;

    @property({ type: String }) userName = 'Vumedi User';
    @property({ type: String }) imageSrc = '';
    @property({ type: String }) imageAlt = '';
    @property({ type: String }) link = '';
    @property({ type: String, reflect: true }) fit = '';

    override connectedCallback() {
        super.connectedCallback();
        if (!this.dataset.colorIndex) {
            const name = this.userName || 'Vumedi User';
            this.dataset.colorIndex = String((name.charCodeAt(0) % 5) + 1);
        }
    }

    override render() {
        const name = this.userName || 'Vumedi User';

        if (this.imageSrc) {
            return html`
                <figure class="vm-profile-image" part="figure">
                    <img src="${this.imageSrc}" alt="${this.imageAlt || `${name} profile image`}" part="image" />
                    ${this.link ? html`<a href="${this.link}" part="link"></a>` : ''}
                </figure>
            `;
        }

        const words = name.split(/\s+/).filter(Boolean);
        const initials =
            words.length >= 2
                ? (words[0]!.charAt(0) + words[1]!.charAt(0)).toUpperCase()
                : name.slice(0, 1).toUpperCase();

        return html`
            <span class="vm-profile-image vm-profile-image--initials" part="initials">
                ${initials} ${this.link ? html`<a href="${this.link}" part="link"></a>` : ''}
            </span>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'vm-profile-image': VmProfileImage;
    }
}
